import React from 'react'
import Header from '../../../Components/Header'

function Rating() {
    return (
        <div>
            <Header text={"Power Rating"} link={'/datasheet/rating'} />
            <div>
                Data
            </div> <br />
        </div>
    )
}

export default Rating